import z from 'zod';

export const zodOptionalNumberInputSchema = z
    .union([z.number(), z.string()])
    .optional()
    .pipe(z.preprocess((val) => (val === '' ? undefined : val), z.coerce.number().optional()));
